import { render, staticRenderFns } from "./Egypt.vue?vue&type=template&id=2ab3bd1c&scoped=true&"
import script from "./Egypt.vue?vue&type=script&lang=js&"
export * from "./Egypt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3bd1c",
  null
  
)

export default component.exports